export enum PlaceholderType {
  SEAL = 'SealPlaceholder',
  SIGNATURE = 'SignaturePlaceholder',
  Annotation = 'AnnotationPlaceholder'
}
